import { render, staticRenderFns } from "./SendMixTip.vue?vue&type=template&id=7cd0577c&scoped=true"
import script from "./SendMixTip.vue?vue&type=script&lang=js"
export * from "./SendMixTip.vue?vue&type=script&lang=js"
import style0 from "./SendMixTip.vue?vue&type=style&index=0&id=7cd0577c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd0577c",
  null
  
)

export default component.exports